const httpConfig = {
  Footer: {
    getListUrl: "pc/columnInfo/getList" //底部数据
  },
  Index: {
    InfoUrl: "/pc/index/findIndexData", //首页模块数据
    indexModuleUlr: "/pc/homeModule/getHomeModuleData",//首页楼层数据
  },
  Login: {
    getCodeUrl: "/pc/people/sendCode", //登录页获取手机验证码
    loginUrl: "pc/people/login" //登录页登录接口
  },
  Register: {
    register: "/pc/people/register", //注册
    companyRegister: "/pc/people/companyRegister" //企业注册
  },
  Category: {
    getListUrl: "/pc/goods/findData" //根据分类id获取商品列表
  },
  Promotion: {
    getListUrl: "/pc/sales/activity/findData_pc" //获取促销活动信息
  },
  ModuleGoods: {
    getListUrl: "/pc/homeModule/getHomeModuleDetail" //获取模块商品
  },
  Cooperation: {
    getInfo: "/app/secondBanner/findAllForIndex", //获取东西协作二级页基本信息
    getListUrl: "/pc/secondBanner/getSecondModuleGoodsList" //东西协作二级页商品
  },
  GoodsInfo: {
    getDataUrl: "/pc/goods/getOne" //根据商品id获取详情
  },
  orderPay: {
    submitUrl: "/pc/order/submit" //提交订单
  },
  proofPay: {
    getInfoUrl: "/app/order/v2/voucher/info", //获取凭证支付信息
    uploadProof: "/pc/order/voucher/pay" //上传支付凭证
  },
  myOrder: {
    getListUrl: "/pc/order/getPeopleOrderInfo", //查询订单
    finishOrderUrl: "/pc/order/finish" //确认收货
  },
  orderDetails: {
    getDataUrl: "/app/order/searchOrderById", //订单详情
    getExpressUrl: "/app/order/getOrderExpressInfo", //获取物流详情
    exportOrderPdfUrl: "/pc/order/exportOrderPdf", //打印订单
    getLogisticsUrl: "/pc/order/getLogistics",//获取物流信息列表
  },
  infoDetails: {
    getDataUrl: "/pc/newsInfo/getOne", //资讯详情
    getTopListByLocation: "/pc/columnInfo/getTopListByLocation"//首页资讯列表
  },
  companyInfo: {
    getInfoUrl: "/pc/people/getOneByPeopleId" //获取企业资质
  },
  upload: {
    url: "/pc/people/upload", //上传图片接口
  },
  retrievePassword: {
    retrievePasswordUrl: '/pc/people/retrievePassword'//找回密码
  },
  changePassword: {
    editPasswordUrl: '/pc/people/editPassword '//修改密码
  },
  bindPhone: {
    editPhoneNoUrl: '/pc/people/editPhoneNo'//手机号绑定
  },
  myAddress: {
    saveAddressUrl: '/pc/people/savePeopleAddress',//新增修改地址
    getAddressUrl: '/pc/people/getPeopleAddressList',//获取地址
    deleteAddressUrl: 'pc/people/deleteAddress'//删除地址
  },
  shopCar: {
    saveShopCarUrl: '/pc/people/savePeopleShoppingCart',//保存修改购物车
    getShopCarUrl: '/pc/people/getPeopleShoppingCart',//获取购物列表
    deleteShopCarUrl: '/pc/people/deleteShoppingCart',//删除购物车
    batchDeleteShopCarUrl: '/pc/people/deleteCartsByPeopleId'//批量删除购物车
  },
  myInvoice: {
    editInvoiceUrl: '/pc/people/savePeopleInvoiceInfo',//保存修改发票信息
    getInvoiceUrl: '/pc/people/getPeopleInvoiceInfos',//获取我的发票
    getInvoiceListUrl: '/pc/invoiceInfo/findData',//获取开票列表
    getInvoiceDetailsUrl: '/pc/invoiceInfo/getDataById',//根据id获取发票详情
    applyInvoiceUrl: '/pc/invoiceInfo/invoiceCreateMergeAndSplit',//申请开票
    deleteInvoiceUrl: '/pc/people/deletePeopleInvoiceInfo',//删除发票
    getInvoiceStatusUrl: '/pc/invoiceInfo/invoiceStatus',//获取发票状态

  },
  myAgreement: {
    getAgreementInfoUrl: "/pc/people/getPeopleAgreementInfo",//获取交易合同等是否已同意
    consentAgreementUrl: "/pc/people/agreeContract",//同意交易合同
    uploadAgreementUrl: "/pc/people/saveAgreementInfo"//上传平台授权附件
  },
  subAccount: {
    getSubAccountUrl: "/pc/people/getPeopleInfoByparentAccount",//查询子账号
    setSubAccountInvoicingUrl: "/pc/people/setSelfInvoicing"//设置是否自主开票
  },
  dataSummary: {
    getListUrl: "/pc/order/dataSummary/findData",//获取订单数据汇总列表信息
    getTotalInfoUrl: '/pc/order/dataSummaryThisYearTotal/findData'//获取订单数据汇总信息
  }

};
export { httpConfig };


// WEBPACK FOOTER //
// ./src/components/common/config.js